import { render } from "./userRegistration.vue?vue&type=template&id=e3c00e22"
import script from "./userRegistration.vue?vue&type=script&lang=ts"
export * from "./userRegistration.vue?vue&type=script&lang=ts"
script.render = render

export default script